import { UpdateRemovalListModel } from './../models/update-removal-list.model';
// @ts-ignore
export const URL_CONSTANT = {

  // urlMaster: '/api-master/',
  urlOriginalMaster: 'https://master.lbasense.com/',
  urlNipaServer: 'https://nipa.lbasense.com/',
};

export const BACKEND_METHOD_CONSTANT = {
  platformId: 8,
  urlStatsSummary: "StatsSummary",
  urlVisitDurations: "VisitDurations",
  urlSpecialFullStats: "builder/SpecialFullStats",
  urlVisitorCountVirtual: "builder/VirtualVisitorsCount",
  urlVisitDurationsVirtual: "builder/VirtualVisitDurations",
  urlReturningVisitorsCountVirtual: "builder/VirtualReturningVisitorsCount",
  mobilityNew: "Mobility",
  mobilityOld: "builder/Mobility",
  dwellVisitStats: "DwellVisitStats",
  analyticsVisitStats: "AnalyticsVisitStats",
  analyticsHistory: "AnalyticsHistory",
  virtualVisitStats: "VirtualVisitStats",
  uniqueVisitors: "UniqueVisitors",
  path: "Path",
  module: "Module",
  filter: "Filter",
  user: "User",
  users: "Users",
  userSite: "UserSite",
  platform: "Platform",
  demographics: "Demographics",
  qManager: "QManagerStats",

  siteDetailUrl: "SiteDetails",
  availableSites: "AvailableSites",
  site: "Site",
  _site: "site",
  server: "Server",
  sensor: "Sensor",
  sensorPassword: "SensorPw",
  gsmStatusReports: "GsmStatusReports",
  btsReports: "BtsReports",
  sensorGsmConfiguration: "SensorGsmConfiguration",
  sensorPerSite: "ListSensorsPerSite",
  sensors: "SensorHealth",
  region: "Region",
  congestion: "Congestion",
  queue: "Queue",
  method: "Method",
  analyticsMethodStats: "AnalyticsMethodStats",
  hardwareList: "Reference/ListHardwareTypes",
  serverReport: "ServerReport/LastRecord",

  addQueue: "AddQueue",
  addDwell: "AddDwell",

  buildSpecialVisitStats: "BuildSpecialVisitStats",

  currentSAPEventTypeValueForSite: "CurrentSAPEventTypeValueForSite",
  currentExtendedListOfPeopleAndEventsPerRegion:
    "CurrentExtendedListOfPeopleAndEventsPerRegion",
  profileHistoryForVisitor: "ProfileHistoryForVisitor",

  identifyVisitor: "IdentifyVisitor",
  visitorDetails: "VisitorDetails",

  listEventsForVisitor: "ListEventsForVisitor",
  addEvent: "AddEvent",
  deleteEvent: "DeleteEvent",
  updateEvent: "UpdateEvent",
  associateEventWithVisitors: "AssociateEventWithVisitors",
  associateModulesWithSite: "AssociateModulesWithSite",
  disassociateModulesWithSite: "DisassociateModulesWithSite",
  associateToVirtualRegion: "AssociateToVirtualRegion",
  disassociateFromVirtualRegion: "DisassociateToVirtualRegion",
  associateWithModule: "AssociateWithModule",
  disassociateFromModule: "DisassociateFromModule",
  createAssociationWithSite: "CreateAssociationWithSite",
  deleteAssociationWithSite: "DeleteAssociationWithSite",

  associateWithSite: "AssociateWithSite",
  disassociateFromSite: "DisassociateFromSite",
  dropInitialized: "DropInitialized",

  createFilterTime: "CreateFilterTime",
  updateFilterTime: "UpdateFilterTime",
  deleteFilterTime: "DeleteFilterTime",
  createFilterPresent: "CreateFilterPresent",
  updateFilterPresent: "UpdateFilterPresent",
  deleteFilterPresent: "DeleteFilterPresent",
  statusMessages: "StatusMessages",
  statusReports: "StatusReports",
  sensorStatusReports: "/SensorStatusReports/WorkCapacity",
  sapCount: "ServerReport/SapCount",
  serverReportHisotry: "ServerReport/ListShort",
  listShortReportTableSize: "ServerReport/ListShortReportTableSize",
  gsm: "Gsm",
  captivePortal: "captive-portal",
  captivePortalReport: "CaptivePortalReport",

  correctionFactorSubstitution: "correction-factor-substitution",

  profiles: "Profiles",
  distributor: "Distributor",

  edgeColudConfiguration: "EdgeCloudConfiguration",

  alert: "Alert",
  Configuration: "Configuration",
  stats: "Stats",

  userTypes: "UserTypes",
  configuration: "configuration",
  firewall: "firewall",

  logs: "Logs",

  Counter: "apis/Counter",
  virtualRegionRegion: "VirtualRegionRegion",
  checkPointServer: "checkpoint-server",
};

export const BACKEND_KEYS = {

  user: 'user',
  pass: 'pass',
  username: 'username',
  password: 'password',
  siteId: 'siteId',
  userId: 'userId',
  userRole: 'role',
  email: 'email',
  phone: 'phoneNum',
  region: 'region',
  regionId: 'regionId',
  congestionId: 'congestionId',
  virtualRegionId: 'virtualRegionId',
  virtualSiteId: 'virtualSiteId',
  isMain: 'isMain',
  moduleId: 'moduleId',
  sensorId: 'sensorId',
  filterId: 'filterId',
  resolution: 'resolution',
  id: 'id',
  name: 'name',
  serverIp: 'serverIp',
  serverId: 'serverId',
  type: 'type',
  address: 'address',
  timezone: 'timezone',
  filterStatusType: 'filterStatusType',
  location: 'location',
  description: 'description',
  minTime: 'minTime',
  maxTime: 'maxTime',
  considerationDays: 'considerationDays',
  presentCount: 'presentCount',
  polygon: 'polygon',
  minSignalStrength: 'minSignalStrength',
  radius: 'radius',
  primarySiteId: 'primarySiteId',
  associatedSites: 'associatedSites',
  activateSensorAlarms: 'activateSensorAlarms',
  pathSettingsId: 'pathSettingsId',
  platformId: 'platformId',
  methodId: 'methodId',
  limit: 'limit',
  start: 'start',
  startIndex: 'startIndex',
  startTime: 'startTime',
  endTime: 'endTime',
  sourceSiteId: 'sourceSiteId',
  distributorUserId: 'distributorUserId',
  module: 'module',
  profileId: 'profileId',
  onlyCount: 'onlyCount',
  page: 'page',
  size: 'size',
  sort: 'sort',
  deleted: 'deleted',
  online: 'online',
  configurationId: 'configurationId',
  statusId: 'statusId',
  shellCommand: 'shellCommand',
  executed: 'executed',
  counterId: 'counterId',
  remoteCommandId: 'remoteCommandId',
  Page: 'Page',
  Size: 'size',
  Sort: 'sort',
  checkpointServerId: 'checkpointServerId',
  site_id: 'site_id',
  num_days_back: 'num_days_back',
  num_days_present: 'num_days_present',
  min_duration_sec: 'min_duration_sec',
  max_duration_sec: 'max_duration_sec',
  start_time: 'start_time',
  end_time: 'end_time',
  update: 'update',
  visitor_id: 'visitor_id',
  reason: 'reason',
};


export const BACKEND_METHOD_TYPES = {

  list: '/List',
  _list: '/list',
  site: '/site',
  create: '/Create',
  update: '/Update',
  reboot: '/Reboot',
  remoteCommand: '/RemoteCommand',
  deleteRemoteCommand: '/DeleteRemoteCommand',
  delete: '/Delete',
  get: '/Get',
  listdelete: '/ListDelete',
  clients: '/Clients/',
  sensors: '/Sensors/',
  profiles: '/Profiles/',
  criteria: '/Criteria/',
  groups: '/Groups/',
  Counters: '/Counters/',
  CountersSites: '/CountersSites/',
  counterId: '',
  removalList: 'api/PermanentDevice/RemovalListStatus/',
  UpdateRemovalList: 'api/PermanentDevice/UpdateRemovalList/',
  updateRemovalListDateTime: 'api/PermanentDevice/RemovalListBasedOnDateTime/',
  addDeviceToRemovalList: 'api/PermanentDevice/AddDeviceToRemovalList/',
  removeDeviceToRemovalList: 'api/PermanentDevice/RemoveDeviceToRemovalList/',
};
